<template>
  <div id="dtBasicExample_wrapper" class="container-fluid">
    <div class="row">
      <div class="col-sm-6 col-md-6">
        <div id="dtBasicExample_filter" class="dataTables_filter">
          <label>
            Buscar:
            <input
              type="search"
              class="form-control form-control-sm"
              placeholder
              aria-controls="dtBasicExample"
              v-model="search"
            />
          </label>
        </div>
      </div>
      <div class="col-sm-6 col-md-6">
        <div class="box-button-add-one">
          <!-- Using value -->
          <b-button class="mt-3" pill variant="primary" v-b-modal="'my-user-modal'">
            <b-icon icon="person"></b-icon>Agregar
          </b-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <table
          id="dtBasicExample"
          class="table table-striped table-bordered table-sm table-responsive-md table-hover"
        >
          <thead class="thead-dark">
            <tr role="row">
              <th>Nombre</th>
              <th>Apellido</th>
              <th>Usuario</th>
              <th>Perfil</th>
              <th>Email</th>
              <th>Telefono</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <UserComponent v-for="(us, key) in filteredList" :user="us" :key="key" />
          </tbody>
        </table>
      </div>
    </div>
    <b-modal
      ref="my-user-modal"
      id="my-user-modal"
      hide-footer
      centered
      ok-only
      @hide="resetInfoModal"
    >
      <UserFormComponent :us="$store.getters.getUserSelected" :update="$store.getters.getIsUpdate" />
    </b-modal>
  </div>
</template>

<script>
import UserComponent from "./User.vue";
import UserFormComponent from "./UserForm.vue";
import { getAllUsers } from "./../../api/conection";

export default {
  name: "userListComponent",
  props: {
    userList: {
      type: Array,
      default: []
    }
  },
  components: {
    UserComponent,
    UserFormComponent
  },
  mounted() {
    getAllUsers()
      .then(response => {        
        if (response.status === 200)
          this.$store.dispatch("setUsersAction", response.body);
      })
      .catch(err => {
        console.log(err);
      });
  },
  computed: {
    filteredList() {
      return this.userList.filter(us => {
        return us.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  methods: {
    resetInfoModal() {
      this.$store.dispatch("unSelectUserAction", {});
    }
  },
  data() {
    return {
      search: ""
    };
  }
};
</script>
<style>
</style>